import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { AR } from '@one-thd/sui-icons';

const { string, func, bool } = proptypes;

// Roomvo integration contract. Their third-party script scans the page for these exact
// class names to mount the "See This In My Room" visualizer, so they are behavioural
// hooks rather than styling and cannot be renamed or replaced with data- attributes.
// Kept out of the literal className strings so they read as API, not as CSS.
const ROOMVO_MOBILE_CONTAINER = 'roomvo-mobile-container--njvut';
const ROOMVO_CONTAINER = 'roomvo-container';
const ROOMVO_TRIGGER = 'roomvo-stimr';

const TRIGGER_CLASSES = 'sui-absolute sui-top-2 sui-right-2 sui-bg-primary sui-invisible sui-btn '
  + 'sui-px-4 sui-rounded-full sui-shadow-xl sui-leading-normal sui-line-clamp-unset '
  + 'sui-normal-case sui-text-base sui-tracking-normal sui-z-10';

const FloatingActionButton = ({
  itemId = '',
  text = 'See This In My Room',
  isMobile = false
}) => {

  return (
    <div className={isMobile ? ROOMVO_MOBILE_CONTAINER : ''} data-component="RoomVo">
      <div className={`${ROOMVO_CONTAINER} sui-w-full sm:sui-w-auto`}>
        <Button
          className={`${ROOMVO_TRIGGER} ${TRIGGER_CLASSES}`}
          data-sku={itemId}
          type="button"
          endIcon={AR}
        >
          {text}
        </Button>
      </div>
    </div>
  );
};

FloatingActionButton.propTypes = {
  itemId: string,
  text: string,
  isMobile: bool
};

export default FloatingActionButton;
